import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

type WorktypeItem = {
  id: string;
  name: string;
  isDefault: boolean;
  isActive: boolean;
};

const getDictionaryWorkTypesMock: WorktypeItem[] = [
  {
    id: '413f4030-19f1-4fd9-995e-0416373a2e83',
    name: 'Diagnostik',
    isDefault: true,
    isActive: true,
  },
  {
    id: '873cfba4-794a-4d10-8654-0266d05898d6',
    name: 'Electrical',
    isDefault: false,
    isActive: false,
  },
  {
    id: 'f9475253-a7f4-48f7-80f9-71b40ede937e',
    name: 'Mechanical',
    isDefault: false,
    isActive: true,
  },
  {
    id: '919b0381-4466-46ca-97d7-a5502ea64009',
    name: 'MPT disabled WT',
    isDefault: false,
    isActive: false,
  },
  {
    id: 'c9eee149-fc00-4d61-bb10-c807829fcfe4',
    name: 'MPT FE refactor',
    isDefault: false,
    isActive: false,
  },
  {
    id: '556190c3-c760-4539-8a51-d33e48259e59',
    name: 'Other',
    isDefault: false,
    isActive: true,
  },
];

const getDictionaryWorkTypesResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/service/v1/codelist/work-types', () =>
      HttpResponse.json(getDictionaryWorkTypesMock)
    )
  );

export const metadaServiceApiMock = {
  getDictionaryWorkTypesMock,
  getDictionaryWorkTypesResponseInterceptor,
};
